import { HardwareConnectionType, PrinterType } from './HardwareDevice';

export enum PrintJobType {
  Receipt = 'receipt',
  GiftCard = 'gift_card',
  CashDrawerKick = 'cash_drawer_kick',
  KitchenReceipt = 'kitchen_receipt',
  FinancialReport = 'financial_report',
  Ticket = 'ticket',
}

export const PrintJobTypeTranslations: Record<PrintJobType, string> = {
  [PrintJobType.Receipt]: 'pos_dashboard.form.field.print_job_receipt',
  [PrintJobType.GiftCard]: 'pos_dashboard.form.field.print_job_gift_card',
  [PrintJobType.CashDrawerKick]: 'pos_dashboard.form.field.print_job_cash_drawer_kick',
  [PrintJobType.KitchenReceipt]: 'pos_dashboard.form.field.print_job_kitchen_receipt',
  [PrintJobType.FinancialReport]: 'pos_dashboard.form.field.print_job_financial_report',
  [PrintJobType.Ticket]: 'pos_dashboard.form.field.print_job_ticket',
};

export enum PrinterTransport {
  Queue = 'queue',
  BrowserPdf = 'browser_pdf',
}

export interface PrintSettingsDevice {
  id: string;
  name: string;
  printer_type: PrinterType;
  transport: PrinterTransport;
  template_key: string | null;
  receipt_format_version: number | null;
  ticket_template_key: string | null;
  online: boolean | null;
}

export interface PrintSettingsAssignment {
  print_job_type: PrintJobType;
  device: PrintSettingsDevice;
}

export interface PosCashDrawerSettings {
  device_id: string;
  connection_type: HardwareConnectionType;
}

export interface PosPrintSettings {
  point_of_sale_id: string;
  has_printer: boolean;
  assignments: PrintSettingsAssignment[];
  cash_drawer: PosCashDrawerSettings | null;
}

export interface PrinterAssignmentInput {
  print_job_type: PrintJobType;
  device_id: string;
}
